import type { Table } from '@tanstack/react-table';

import { ViewByAmountSelect } from 'components/partials/table-component/view-by-amount-select/view-by-amount-select';
import { Pagination } from 'components/partials/table-component/pagination/pagination';
import type { TableAmountState } from 'components/partials/table-component/table-component';

interface PaginationWrapperProps {
  showingRecordsTextIsOn: boolean;
  viewByAmountSelectIsOn: boolean;
  table: Table<unknown>;
  pageIndex: number;
  pageSize: number;
  totalRecords: number;
  pagesAmount: number;
  setAmount:
    | ((updater: (state: TableAmountState) => TableAmountState) => void)
    | undefined;
}

const PaginationWrapper = ({
  showingRecordsTextIsOn,
  viewByAmountSelectIsOn,
  table,
  pageIndex,
  pageSize,
  totalRecords,
  pagesAmount,
  setAmount,
}: PaginationWrapperProps): React.JSX.Element => (
  <div className="flex items-center gap-6">
    <Pagination
      table={table}
      pagesAmount={pagesAmount}
      pageIndex={pageIndex}
      pageSize={pageSize}
      totalRecords={totalRecords}
      showRecordsText={showingRecordsTextIsOn}
    />
    {viewByAmountSelectIsOn && (
      <ViewByAmountSelect
        table={table}
        pageSize={pageSize}
        setAmount={setAmount}
      />
    )}
  </div>
);

export default PaginationWrapper;
